import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import CardTypeInput from "../../../components/CardTypeInput";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import { getCardType } from "../../../utils/ApiCalls/CardTypes";
import { getDrsInstance } from "../../../utils/ApiCalls/DrsInstance";
import DRSinstanceInput from "../../../components/DRSinstanceInput";

const EditDrsInstance = () => {
  const params = useParams();
  const [cardtype, setCardType] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "DRS Instance",
      route: "/website/loyalty/drs-instance",
    },
    {
      title: "Edit DRS Instance",
      route: "/website/loyalty/drs-instance/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getDrsInstance({ id: value });

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setCardType(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"DRS Instance"}>
      <CustomHeaderTitle title={"Edit DRS Instance"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit DRS Instance"}
      ></HeaderBread>
      {cardtype && <DRSinstanceInput drsinatance={cardtype} />}
    </Layout>
  );
};

export default EditDrsInstance;
